enum DeliveryCostServiceName {
    ALL = "ALL",
    MONEY_DELIVERY = "MONEY_DELIVERY",
    PACKAGE_DELIVERY = "PACKAGE_DELIVERY",
    ARTICLE_DELIVERY = "ARTICLE_DELIVERY",
    MISCELLANY = "MISCELLANY",
}

export default DeliveryCostServiceName;